import { productIdFormat } from "@redotech/redo-product-id";
import { restrictionMeasureIdFormat } from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";
import { restrictionTier } from "./restriction-tier-output";

export const productRestrictionOutput = z.object({
  measureId: restrictionMeasureIdFormat.schema,
  isResolved: z.boolean(),
  destinationCountryCode: z.string(),
  tier: restrictionTier,
  category: z.string().nullable(),
  matchHsCode: z.string(),
  confidenceScore: z.number().nullable(),
  summary: z.string(),
  sourceUrl: z.string().nullable(),
  lastSeenAt: z.date(),
  /** Merchant-set publish override for this product x country; null = unset. */
  publishOverride: z.boolean().nullable(),
});

export const getProductRestrictions = {
  name: "getProductRestrictions" as const,
  input: z.object({ productId: productIdFormat.schema }),
  output: z.object({
    restrictions: z.array(productRestrictionOutput),
    lanes: z.array(
      z.object({
        destinationCountryCode: z.string(),
        lastScreenedAt: z.date().nullable(),
      }),
    ),
    hideRestricted: z.boolean(),
  }),
};
